module.exports = __webpack_public_path__ + "media/promo/promo/images/chief-glow-1-9474807c533e7d977ab4a015fbb4721d.png";